/**
 * @generated SignedSource<<551f69212b2d2dd1a6b83dc5e73364e4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type PasswordResetInput = {
  password: string;
  passwordConfirmation: string;
  token: string;
  userContext?: string | null | undefined;
};
export type useRegisterNewAccountMutation$variables = {
  input: PasswordResetInput;
};
export type useRegisterNewAccountMutation$data = {
  readonly responsePayload: {
    readonly errors: ReadonlyArray<{
      readonly code: string;
      readonly message: string | null | undefined;
    } | null | undefined>;
    readonly success: boolean;
  } | null | undefined;
};
export type useRegisterNewAccountMutation = {
  response: useRegisterNewAccountMutation$data;
  variables: useRegisterNewAccountMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "success",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useRegisterNewAccountMutation",
    "selections": [
      {
        "alias": "responsePayload",
        "args": (v1/*: any*/),
        "concreteType": "PasswordResetPayload",
        "kind": "LinkedField",
        "name": "passwordReset",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootMutationType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useRegisterNewAccountMutation",
    "selections": [
      {
        "alias": "responsePayload",
        "args": (v1/*: any*/),
        "concreteType": "PasswordResetPayload",
        "kind": "LinkedField",
        "name": "passwordReset",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v3/*: any*/),
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "650b3e7ff28123521de6fbf0ef1bab5d",
    "id": null,
    "metadata": {},
    "name": "useRegisterNewAccountMutation",
    "operationKind": "mutation",
    "text": "mutation useRegisterNewAccountMutation(\n  $input: PasswordResetInput!\n) {\n  responsePayload: passwordReset(input: $input) {\n    success\n    errors {\n      __typename\n      code\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "d62d3c34962d89e2dc5d340e91fde2a8";

export default node;
